<script>
    export default {
        name: "Head Block",
        props: {
            headerText: {
                type: String,
                required: true,
                default: "Заголовок"
            },
            isAddNew: {
                type: Boolean,
                required: true,
                default: false
            },
            addNewText: {
                type: String,
                required: true
            }
        },
    }
</script>

<template>
    <div class="head-block">
        <h2 class="header-text">{{ headerText }}</h2>
        <div v-if="isAddNew">
            <router-link class="add-new" :to="this.$route.path + '/add-new'">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.28571 5.71429H0V4.28571H4.28571V0H5.71429V4.28571H10V5.71429H5.71429V10H4.28571V5.71429Z" fill="#DC33DF"/>
                </svg>

                <span>{{ addNewText }}</span>
            </router-link>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
.head-block {
        min-width: 50%;
        text-align: left;

        display: flex;
        align-items: center;
        gap: 4%;
    }

    .header-text {
        font-size: 26px;
        font-weight: 500;
    }

    .add-new {
        display: flex;
        align-items: center;
        gap: 7%;
        color: $purple;
        text-wrap: nowrap;
        min-width: 30px;

        cursor: pointer;
        transition: $transition;
    }

    .add-new span {
        color: $purple;
    }

    .add-new svg path {
        transition: $transition;
    }

    .add-new span {
        min-width: inherit;
        font-size: 14px;
        font-weight: 500;
    }

    .add-new:hover {
        color: $purple-hover;
    }

    .add-new:hover svg path {
        fill: $purple-hover;
    }
</style>
